import { SdohSingleAnswerAdvanced } from './SdohSingleAnswerAdvanced.model';

export default interface IFamilyAndHome {
    FamilyMembersCurrentlyLiveWithYou: SdohSingleAnswerAdvanced | null;
    HousingSituationToday: SdohSingleAnswerAdvanced | null;
    WorriedAboutLosingYourHousing: SdohSingleAnswerAdvanced | null;
    CurrentLivingSituation: SdohSingleAnswerAdvanced | null;
    LivingSituationType: SdohSingleAnswerAdvanced | null;
    CurrentLivingConditions: SdohSingleAnswerAdvanced | null;
    IsAIFamilyMembersCurrentlyLiveWithYou?: boolean;
    IsAIHousingSituationToday?: boolean;
    IsAIWorriedAboutLosingYourHousing?: boolean;
    IsAICurrentLivingSituation?: boolean;
    IsAILivingSituationType?: boolean;
    IsAICurrentLivingConditions?: boolean;
}

export class FamilyAndHome implements IFamilyAndHome {
    FamilyMembersCurrentlyLiveWithYou: SdohSingleAnswerAdvanced | null;
    HousingSituationToday: SdohSingleAnswerAdvanced | null;
    WorriedAboutLosingYourHousing: SdohSingleAnswerAdvanced | null;
    CurrentLivingSituation: SdohSingleAnswerAdvanced | null;
    LivingSituationType: SdohSingleAnswerAdvanced | null;
    CurrentLivingConditions: SdohSingleAnswerAdvanced | null;
    IsAIFamilyMembersCurrentlyLiveWithYou?: boolean;
    IsAIHousingSituationToday?: boolean;
    IsAIWorriedAboutLosingYourHousing?: boolean;
    IsAICurrentLivingSituation?: boolean;
    IsAILivingSituationType?: boolean;
    IsAICurrentLivingConditions?: boolean;

    constructor() {
        this.FamilyMembersCurrentlyLiveWithYou = new SdohSingleAnswerAdvanced();
        this.HousingSituationToday = new SdohSingleAnswerAdvanced();
        this.WorriedAboutLosingYourHousing = new SdohSingleAnswerAdvanced();
        this.CurrentLivingSituation = new SdohSingleAnswerAdvanced();
        this.LivingSituationType = new SdohSingleAnswerAdvanced();
        this.CurrentLivingConditions = new SdohSingleAnswerAdvanced();
    }
}
